/*!
 * Copyright © 2026. Verizon Connect Ireland Limited. All rights reserved.
 */

/**
 * Lifecycle status of the ECM side panel.
 *
 * - `Closed`: the panel is not shown (initial state).
 * - `Loading`: the diagnostics HTTP call is in flight.
 * - `Open`: the call has finished and the side panel is shown (with data or, on failure, with errors).
 */
export enum EEcmPanelStatus {
  Closed = 'CLOSED',
  Loading = 'LOADING',
  Open = 'OPEN'
}
